export default __webpack_public_path__ + "static/overpass-lotus-headlines-0e516c5abe0a55da55325a42869d7b63.woff";